<mat-card class="car-card-buyer" >
  <div class="car-image">
    <div class = "image-container">
      @if (carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0) {
        <p class="spinner">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>
      }
      <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.webp'" alt="Car Image">
      <div class = "img-arrow-container">
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
        </div>
      }
    </div>
    <div class = "image-thumbs">

      @for (file of carImagesFolder  ; track file; let i = $index) {
        <div class="image-thumb"
          [style.border-color]=" (i===currentImageIndex) ? 'yellow': 'white'">
          <!-- <p class="spinner" *ngIf="carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>  -->
        <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
        -->
        <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
        <img mat-card-image
          [src]="(carImagesFolder.length! > 0) ? getCarImage(i) : 'assets/images/car_image_holder.png'" alt="Car Image"
          (click)="selectImage(i)"
          >
        </div>
      }
    </div>

    <!-- <div class="buyer-actions">
    <button class="cta-button"  mat-button (click)="openOfferDialog(car.carId) ;$event.stopPropagation()">Faire une offre<mat-icon>attach_money</mat-icon></button>
  </div> -->

  <div class="car-infos">
    <h3>{{car.make}} {{car.model}} {{car.version}}, {{car.year }}</h3>
    @if (businessLine===CarBusinessLine.BUY) {
      <h3>{{ moneyFormat(""+$safeNavigationMigration(car.buyPrice?.amount)) }} {{ car.buyPrice?.currency }}</h3>
    }
    @if (businessLine===CarBusinessLine.RENT) {
      <h3>{{ moneyFormat(""+$safeNavigationMigration(car.rentDayRate?.amount)) }} {{ car.rentDayRate?.currency }}/J</h3>
    }

    <h6><mat-icon>directions_car</mat-icon>{{car.fuel}}, {{car.gearBox }}, {{car.mileage}} KM</h6>

    <h6><mat-icon>location_on</mat-icon>{{car.city}}, {{car.country}}</h6>

    @if (businessLine===CarBusinessLine.BUY) {
      <h6> <mat-icon>person</mat-icon>Vendu par <b>{{car.providerName}}</b></h6>
    }
    @if (businessLine===CarBusinessLine.RENT) {
      <h6> <mat-icon>person</mat-icon>Mis en location par <b>{{car.providerName}}</b></h6>
    }

    <h6 class="date">Postée: {{dateFormat(car.created)}} / Mis a jour: {{dateFormat(car.lastUpdated)}}</h6>

  </div>

  <div class="buyer-actions">
    <div>
      <button matButton class="simple-button" mat-button matTooltipPosition="above" matTooltip="View car details" (click)="goToCarDetailsPage(car.carId, car.offerId);$event.stopPropagation()">Détails<mat-icon>open_in_new</mat-icon> </button>
    </div>
    <div>
      <button matButton class="simple-button" mat-button matTooltipPosition="above" matTooltip="abandon" (click)="toggleFavorite(car.carId);$event.stopPropagation()" >Enlever<mat-icon>delete</mat-icon> </button>
    </div>
    <div>
      <button matButton class="simple-button" mat-button matTooltipPosition="above" matTooltip="Share">Partager<mat-icon>share</mat-icon> </button>
    </div>
  </div>
</div>
<div class="car-data">

  <mat-accordion multi>

    @if (car.proposals != undefined && businessLine==CarBusinessLine.BUY) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4> Propositions envoyées <span>({{car.proposals.length}}) </span></h4>
            @if (canNewProposal()) {
              <button
                class="simple-button-buy"  mat-button (click)="openProposalDialog(0, false);$event.stopPropagation()">
                <mat-icon>add</mat-icon> Nouvelle
              </button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <div class="section-title">
          </div>
          <app-proposals
            [objectSource]="objectSource"
            [offerId]="car.offerId">
          </app-proposals>
          <!--
          <span *ngIf="!(car.proposals.length > 0)">
            Aucune proposition en cours
          </span>
          <div class="proposal-list" *ngIf="!(car.proposals == undefined || car.proposals.length === 0 )">
            <div class="proposal" *ngFor="let proposal of car.proposals; index as i">
              <h6> Type:  {{proposal.type}}, Proposer ID: {{proposal.proposerId}} </h6>
              <h6> Date demandée: {{dateFormat(proposal.appointmentDate)}}</h6>
              <h6> Offre: {{proposal.offer.amount}}{{proposal.offer.currency}}</h6>
              <h6> Commentaire: {{proposal.comment}}</h6>
              <h6> Date report demandée: {{dateFormat(proposal.rescheduleDate)}}</h6>
              <h6> Date création: {{dateFormat(proposal.created)}}</h6>
              <h6> Dernière mise a jour: {{dateFormat(proposal.lastUpdated)}}</h6>
              <h6> Statut: <b>{{proposal.status}}</b></h6>
              <div class="proposal-buttons">
                <button *ngIf="(proposal.status === ProposalStatus.PROPOSED )"
                  class="simple-button"  mat-button (click)="openProposalDialog(proposal.carId, proposal);$event.stopPropagation()">
                  Editer <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="(proposal.status === ProposalStatus.SCHEDULED)"
                  class="simple-button"  mat-button (click)="rescheduleProposal(proposal);$event.stopPropagation()">
                  Changer date <mat-icon>calendar</mat-icon>
                </button>
                <button *ngIf="(proposal.status === ProposalStatus.SELLER_RESC)"
                  class="simple-button"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.SCHEDULED);$event.stopPropagation()">
                  Accepter <mat-icon>accept</mat-icon>
                </button>
                <button *ngIf="(proposal.status !== ProposalStatus.CANCELLED)"
                  class="simple-button"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.CANCELLED);$event.stopPropagation()">
                  Annuler <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </div>
          </div>        -->
        </div>
      </mat-expansion-panel>
    }

    @if (car.myBookings != undefined && businessLine==CarBusinessLine.RENT) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4> Réservations en cours <span>({{car.myBookings.length}}) </span></h4>
            <button
              class="simple-button-rent"  mat-button (click)="openBookingDialog(0);$event.stopPropagation()">
              <mat-icon>add</mat-icon> Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-bookings
          [objectSource]="objectSource"
          [offerId]="car.offerId"
          [enableNew]="false">
        </app-bookings>
      </mat-expansion-panel>
    }


    @if (car.appointments != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Rendez vous <span >({{car.appointments.length}}) </span></h4>
            @if (canNewAppointment()) {
              <button
                class="simple-button-{{businessLine.toLowerCase()}}"  mat-button (click)="openAppointmentDialog(0, false);$event.stopPropagation()">
                <mat-icon>add</mat-icon> Nouveau
              </button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <div class="section-title">
          </div>
          <app-appointments
            [objectSource]="objectSource"
            [offerId]="car.offerId">
          </app-appointments>
          <!--
          <span *ngIf="!(car.appointments.length > 0)">
            Aucun rendez vous en cours
          </span>
          <div class="appointment-list" *ngIf="!(car.appointments == undefined || car.appointments.length === 0 )">
            <div class="appointment" *ngFor="let appointment of car.appointments; index as i">
              <h6> Buyer Id: {{appointment.customerId}}</h6>
              <h6> Service: {{appointment.services}}, Lieu: {{appointment.locationMode}}, Rappel : {{appointment.needCallback}} </h6>
              <h6> Détails: {{appointment.details}}</h6>
              <h6> Date: {{dateFormat(appointment.appointmentDate)}}</h6>
              <h6> Date report demandée: {{dateFormat(appointment.rescheduleDate)}}</h6>
              <h6> Date création: {{dateFormat(appointment.created)}}</h6>
              <h6> Dernière mise a jour: {{dateFormat(appointment.lastUpdated)}}</h6>
              <h6> Statut: <b>{{appointment.status}}</b></h6>
              <div class="appointment-buttons">
                <button *ngIf="(appointment.status === AppointmentStatus.PROPOSED)"
                  class="simple-button"  mat-button (click)="openAppointmentDialog(car.carId, appointment);$event.stopPropagation()">
                  Editer <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="(appointment.status === AppointmentStatus.SCHEDULED)"
                  class="simple-button"  mat-button (click)="rescheduleAppointment(appointment);$event.stopPropagation()">
                  Changer date <mat-icon>calendar</mat-icon>
                </button>
                <button *ngIf="(appointment.status === AppointmentStatus.SELLER_RESC)"
                  class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.SCHEDULED);$event.stopPropagation()">
                  Accepter <mat-icon>accept</mat-icon>
                </button>
                <button *ngIf="(appointment.status !== AppointmentStatus.CANCELLED)"
                  class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.CANCELLED);$event.stopPropagation()">
                  Annuler <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </div>
          </div>        -->
        </div>
      </mat-expansion-panel>
    }


    @if (car.conversations != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Conversations <span >({{car.conversations.length}}) </span></h4>
            @if ((car.conversations == undefined || car.conversations.length === 0 )) {
              <button
                class="simple-button-{{businessLine.toLowerCase()}}"  mat-button (click)="openConversationDialog();$event.stopPropagation()">
                Contacter<mat-icon>email_new</mat-icon>
              </button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <div class="section-title">
          </div>
          @if (!(car.conversations == undefined || car.conversations.length === 0 )) {
            <div class="conversations">
              <app-conversations
                [objectSource]="objectSource"
                [offerId]="car.offerId"
                >
              </app-conversations>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
    <!--
    [conversations]="car.conversations"
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Conversations <span *ngIf="car.conversations.length > 0">({{car.conversations.length}}) </span></h4>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="car-data-section">
        <div class="section-title">

        </div>

        <h6 *ngIf="(car.conversations == undefined || car.conversations.length === 0 )">
          Aucune conversation en cours
        </h6>

        <div class="conversation-list">
          <app-conversation-list
            [conversations]="car.conversations"
            >
          </app-conversation-list>
        </div>
      </div>
    </mat-expansion-panel>  -->

  </mat-accordion>

  <!-- <div class="car-data-section">
  <div class="section-title">
    <h3> Proposition envoyée </h3>
    <button *ngIf="(car.proposals == undefined || car.proposals.length === 0 )"
      class="cta-button"  mat-button (click)="openProposalDialog(car.carId, undefined);$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button>
  </div>

  <span *ngIf="!(car.proposals.length > 0)">
    Aucune proposition en cours
  </span>

  <div class="proposal-list" *ngIf="!(car.proposals == undefined || car.proposals.length === 0 )">
    <div class="proposal" *ngFor="let proposal of car.proposals; index as i">
      <h6> Customer Id: {{proposal.customerId}}</h6>

      <h6> Date demandée: {{dateFormat(proposal.appointmentDate)}}</h6>
      <h6> Offre: {{proposal.offerAmount}}</h6>
      <h6> Commentaire: {{proposal.comment}}</h6>
      <h6> Date report demandée: {{dateFormat(proposal.rescheduleDate)}}</h6>

      <h6> Date création: {{dateFormat(proposal.created)}}</h6>
      <h6> Dernière mise a jour: {{dateFormat(proposal.lastUpdated)}}</h6>

      <h6> Statut: <b>{{proposal.status}}</b></h6>


      <div class="proposal-buttons">
        <button *ngIf="(proposal.status === ProposalStatus.PROPOSED )"
          class="simple-button"  mat-button (click)="openProposalDialog(proposal.carId, proposal);$event.stopPropagation()">
          Editer <mat-icon>edit</mat-icon>
        </button>

        <button *ngIf="(proposal.status === ProposalStatus.SCHEDULED)"
          class="simple-button"  mat-button (click)="rescheduleProposal(proposal);$event.stopPropagation()">
          Changer date <mat-icon>calendar</mat-icon>
        </button>

        <button *ngIf="(proposal.status === ProposalStatus.SELLER_RESC)"
          class="simple-button"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.SCHEDULED);$event.stopPropagation()">
          Accepter <mat-icon>accept</mat-icon>
        </button>
        <button *ngIf="(proposal.status !== ProposalStatus.CANCELLED)"
          class="simple-button"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.CANCELLED);$event.stopPropagation()">
          Annuler <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="car-data-section">
<div class="section-title">
  <h3> Rendez vous </h3>
  <button *ngIf="(car.appointments == undefined || car.appointments.length === 0 )"
    class="cta-button"  mat-button (click)="openAppointmentDialog(car.carId, undefined);$event.stopPropagation()">
    Nouvelle<mat-icon>add</mat-icon>
  </button>
</div>

<span *ngIf="!(car.appointments.length > 0)">
  Aucun rendez vous en cours
</span>

<div class="appointment-list" *ngIf="!(car.appointments == undefined || car.appointments.length === 0 )">
  <div class="appointment" *ngFor="let appointment of car.appointments; index as i">
    <h6> Buyer Id: {{appointment.customerId}}</h6>

    <h6> Service: {{appointment.service}}, Lieu: {{appointment.locationMode}}, Rappel : {{appointment.needCallback}} </h6>

    <h6> Détails: {{appointment.details}}</h6>

    <h6> Date: {{dateFormat(appointment.appointmentDate)}}</h6>

    <h6> Date report demandée: {{dateFormat(appointment.rescheduleDate)}}</h6>

    <h6> Date création: {{dateFormat(appointment.created)}}</h6>
    <h6> Dernière mise a jour: {{dateFormat(appointment.lastUpdated)}}</h6>

    <h6> Statut: <b>{{appointment.status}}</b></h6>


    <div class="appointment-buttons">
      <button *ngIf="(appointment.status === AppointmentStatus.PROPOSED)"
        class="simple-button"  mat-button (click)="openAppointmentDialog(car.carId, appointment);$event.stopPropagation()">
        Editer <mat-icon>edit</mat-icon>
      </button>

      <button *ngIf="(appointment.status === AppointmentStatus.SCHEDULED)"
        class="simple-button"  mat-button (click)="rescheduleAppointment(appointment);$event.stopPropagation()">
        Changer date <mat-icon>calendar</mat-icon>
      </button>

      <button *ngIf="(appointment.status === AppointmentStatus.SELLER_RESC)"
        class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.SCHEDULED);$event.stopPropagation()">
        Accepter <mat-icon>accept</mat-icon>
      </button>
      <button *ngIf="(appointment.status !== AppointmentStatus.CANCELLED)"
        class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.CANCELLED);$event.stopPropagation()">
        Annuler <mat-icon>cancel</mat-icon>
      </button>
    </div>
  </div>
</div>
</div>  -->

<!-- <div class="car-data-section">
<div class="section-title">
  <h3> Discussions ({{car.conversations.length}})</h3>
  <button *ngIf="(car.conversations == undefined || car.conversations.length === 0 )"
    class="simple-button"  mat-button (click)="openConversationDialog(car.carId);$event.stopPropagation()">
    Contacter<mat-icon>email_new</mat-icon>
  </button>
</div>

<div class="conversation-list" *ngIf="!(car.conversations == undefined || car.conversations.length === 0 )">
  <app-conversation-list
    [conversations]="car.conversations"
    >
  </app-conversation-list>
</div>
</div>  -->
</div>
</mat-card>
